
import React, { useState, useEffect, useRef, useCallback } from "react";
import moment from "moment";
import axios from "axios";
import camera from "../../../assets/camera_cashierfraud.png";
import SearchBar from "./SearchBar.tsx";
import { DataTable as CustomDataTable } from "../../../components/DataTable/index.ts";
import type { Column as CustomColumn } from "../../../components/DataTable/index.ts";
import { StatusChip } from "../../../components/StatusChip/index.ts";
import { Dialog } from 'primereact/dialog';
import TriggerFilterModal from "./TriggerFilterModal.tsx";
import TriggerTableInnerSkeleton from "./TriggerTableInnerSkeleton.tsx";
import { toast } from "../../../components/Toast/toast.ts";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { ProgressSpinner } from 'primereact/progressspinner';
import Drawer from "./TriggerAlertDrawer.tsx";
import CustomVideoPlayer from "../../../components/CustomVideoPlayer/CustomVideoPlayerWithPrevNextBtn.tsx"
import { useMediaQuery } from '@mui/material';
import { useUserContext } from "../../../context/UserContext.tsx";
import DescriptionBox from "../../../components/DescriptionBox/index.tsx";
import VideoDialog from "../../../components/VideoDialog/VideoDialog.tsx";
import VideoSidebar from "../../../components/VideoDialog/VideoSidebar.tsx";

export default function TriggerAlert() {
    const videoRef = useRef(null);
    const [Data, setData] = React.useState<any>([]);
    const [reload, setReload] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [innerLoading, setInnerLoading] = React.useState(false);
    const [isAllDataFetched, setIsAllDataFetched] = useState(false);
    const [isInnerDataLoading, setInnerDataLoading] = useState(false);
    const [videoHeader, setVideoHeader] = React.useState("");
    const [visible, setVisible] = React.useState(false);
    const [searchVal, setSearchVal] = useState('');
    const [filterVal, setFilterVal] = React.useState(false);
    const [totalCount, setTotalCount] = React.useState(0);
    const [currentCount, setCurrentCount] = useState(20);
    const [currentFilterCount, setCurrentFilterCount] = useState(20);
    const [status, setStatus] = React.useState('');
    const [todate, setTodate] = React.useState(null);
    const [fromdate, setFromdate] = React.useState(null);
    const [currentVideoIndex, setCurrentVideoIndex] = React.useState(0);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [count, setCount] = React.useState(null);
    const [videoSrc, setVideoSrc] = useState('');
    const [currentTime, setCurrentTime] = useState(0);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [videoLoading, setVideoLoading] = useState({});
    const [openDrawer, setOpenDrawer] = useState(false)
    const isMobile = useMediaQuery('(max-width: 600px)');
    const { globalstorevalue } = useUserContext();

    const handlePrevVideo = () => {
        try {
            const prevIndex = currentVideoIndex - 1;
            // console.log(prevIndex)
            if (prevIndex >= 0) {
                const prevVideo = Data[prevIndex];
                const video = videoRef.current;
                if (prevVideo?.video_link) {
                    if (video) {
                        video.currentTime = 0;  // Reset playback time
                        video.load();  // Reload video to start from beginning
                    }
                    setVideoSrc(prevVideo.video_link);
                    setVideoHeader(prevVideo.store_name);
                    setCurrentVideoIndex(prevIndex);
                } else {
                    // Handle "No Video Available" case
                    setVideoSrc(null); // Set video source to null
                    setVideoHeader(prevVideo?.store_name || "No Video Available"); // Set header to store name or fallback message
                    setCurrentVideoIndex(prevIndex);
                    // toast.warn("No video available for the selected transaction alert."); // Show a toast warning
                }
            }
        } catch (error) {
            toast.error("Failed to load previous video.");
        }
    };

    const handleNextVideo = async () => {
        try {
            const nextIndex = currentVideoIndex + 1;
            // console.log("Next video index:", nextIndex);
            if (nextIndex >= Data.length - 1) {
                // Trigger lazy load if next video is not yet loaded
                filterVal ? await handleFilteredResultLazyLoad() : await handleLazyLoad()
            }
            if (nextIndex < Data.length) {
                const nextVideo = Data[nextIndex];
                const video = videoRef.current;
                if (nextVideo?.video_link) {
                    if (video) {
                        video.currentTime = 0;  // Reset playback time
                        video.load();  // Reload video to start from beginning
                    }
                    setVideoSrc(nextVideo.video_link);
                    setVideoHeader(nextVideo.store_name);
                    setCurrentVideoIndex(nextIndex);
                } else {
                    // Handle "No Video Available" case
                    setVideoSrc(null); // Set video source to null
                    setVideoHeader(nextVideo?.store_name || "No Video Available"); // Set header to store name or fallback message
                    setCurrentVideoIndex(nextIndex);
                    toast.warn("No video available for the selected transaction alert."); // Show a toast warning
                }
            }
        } catch (error) {
            toast.error("Failed to load next video.");
        }
    };

    const formatDate = (dateString) => {
        return <span className="triggers-page-date" style={{ fontSize: "13px" }}>{moment(dateString).format('DD/MM/YYYY  hh:mm:ss A')}</span>;
    };

    const storedToken = localStorage.getItem('token');

    const handleOpenDialog = useCallback((rowData, rowIndex) => {
        try {
            if (rowData?.video_link && rowData?.store_name) {
                setVideoSrc(rowData?.video_link);
                setVideoHeader(rowData?.store_name);
                setCurrentVideoIndex(rowIndex);
                if (!isMobile) {
                    setOpenDrawer(true);   // open drawer only on large screens
                }
                setVisible(true);
            }
        } catch (error) {
            toast.error("Failed to open video. Please try again.");
        }
    }, [setVideoSrc, setVideoHeader, setCurrentVideoIndex, setVisible]);

    const handleCloseDialog = () => {
        if (currentVideoIndex !== null && Data[currentVideoIndex]) {
            // if (isButtonClicked) {
            const reportElement = document.querySelector(`.report-${Data[currentVideoIndex]._id}`
            );

            if (reportElement) {
                reportElement.classList.add("highlight-row");

                // Scroll to the row
                reportElement.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
                // console.log("Scrolled to:", reportElement, currentVideoIndex);
            }

            setTimeout(() => {
                reportElement?.classList.remove("highlight-row");
            }, 10000)
            //}
        }
        setVisible(false); // Close the modal
        // setIsButtonClicked(false);
    };

    const fetchCountAndData = async () => {
        if (storedToken) {
            try {
                setLoading(true);
                setIsAllDataFetched(false);

                let count = await axios.get(
                    `${process.env.REACT_APP_API_URL}/api/cust-portal/push-button-alerts/meta?${globalstorevalue ? `stores=${globalstorevalue}` : ''}${searchVal ? `&search=${searchVal}` : ""}`,
                    {
                        headers: {
                            Authorization: `Bearer ${storedToken}`,
                        },
                    }
                );

                setTotalCount(count?.data?.count); // Update total count

                if (count?.data?.count > 0) {
                    if (count?.data?.count <= 20) {
                        setLoading(true);
                        setIsAllDataFetched(true);
                        let alerts = await axios.get(
                            `${process.env.REACT_APP_API_URL}/api/cust-portal/push-button-alerts?first=0&rows=${count.data.count}${globalstorevalue ? `&stores=${globalstorevalue}` : ''}${searchVal ? `&search=${searchVal}` : ""}`,
                            {
                                headers: {
                                    Authorization: `Bearer ${storedToken}`,
                                },
                            }
                        );
                        setData(alerts?.data); // Update data only if there's data
                        setCurrentCount(20)
                        setLoading(false);
                    } else {
                        // setCurrentFilterCount(10)
                        const reports = await axios.get(
                            `${process.env.REACT_APP_API_URL}/api/cust-portal/push-button-alerts?first=0&rows=20${globalstorevalue ? `&stores=${globalstorevalue}` : ""}${searchVal ? `&search=${searchVal}` : ""}`,
                            {
                                headers: {
                                    Authorization: `Bearer ${storedToken}`,
                                },
                            }
                        )
                        setData(reports?.data)
                        setCurrentCount(20)
                        setLoading(false);
                    }
                }
            } catch (error) {
                toast.error("Unable to retrieve trigger alerts data!");
            } finally {
                setLoading(false);
            }
        };
    }

    React.useEffect(() => {
        if (filterVal) {
            fetchFilteredData()
        } else {
            fetchCountAndData()
        }
    }, [globalstorevalue])

    useEffect(() => {
        if (visible && videoHeader) {
            try {

                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                    event: 'video_opened',
                    storeName: videoHeader,
                });

                window.dataLayer.push({
                    storeName: undefined,
                });

            } catch (error) {
                console.error('Error handling videoHeader:', error);
            }
        }
    }, [visible, videoHeader]);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { store_name, time, reason, video_link, resolution_status } = Data || {};

    async function handleLazyLoad() {
        if (isAllDataFetched) return;

        let newFirst = currentCount;
        setInnerLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/cust-portal/push-button-alerts?first=${newFirst}&rows=20${globalstorevalue ? `&stores=${globalstorevalue}` : ""}`, {
                headers: {
                    Authorization: `Bearer ${storedToken}`,
                }
            });

            const newData = response?.data || [];

            if (newData.length === 0) {
                setIsAllDataFetched(true);
                setCurrentCount(20);
            } else {
                setData((prevData) => [...prevData, ...newData]);
                //console.log(newData)

                // Reset videoLoading state for newly loaded videos
                const newVideoLoadingState = {};
                newData.forEach(video => {
                    if (video?.video_link) {
                        newVideoLoadingState[video.video_link] = true; // Set loading state to true initially
                    }
                });
                setVideoLoading((prev) => ({ ...prev, ...newVideoLoadingState }));

                setCurrentCount((prevCount) => prevCount + newData.length);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message || "An error occurred. Please try again.");
        } finally {
            setInnerLoading(false);
        }
    }

    const fetchFilteredData = async () => {
        try {
            setIsAllDataFetched(false);
            setCurrentFilterCount(20)
            if (storedToken) {
                // Fetch user data 
                setFilterVal(true);
                setLoading(true);
                const filterAndSearchUrl = `${process.env.REACT_APP_API_URL}/api/cust-portal/push-button-alerts/meta?${fromdate ? `rangeDates=${fromdate}` : ""}${todate ? `&rangeDates=${todate}` : ""}${globalstorevalue ? `&stores=${globalstorevalue}` : ""}${status && status !== "All Status" ? `&status=${status}` : ""}${searchVal ? `&search=${searchVal}` : ""}`
                const count = await axios.get(filterAndSearchUrl,
                    {
                        headers: {
                            Authorization: `Bearer ${storedToken}`,
                        },
                    }
                )
                setTotalCount(count?.data?.count)
                setLoading(false);
                if (count?.data?.count > 0) {
                    if (count.data.count <= 20) {
                        setLoading(true);
                        setIsAllDataFetched(true);
                        // setCurrentFilterCount(10)
                        const filterAndSearchUrl = `${process.env.REACT_APP_API_URL}/api/cust-portal/push-button-alerts?first=0&rows=${count.data.count}&${fromdate ? `rangeDates=${fromdate}` : ""}${todate ? `&rangeDates=${todate}` : ""}${globalstorevalue ? `&stores=${globalstorevalue}` : ""}${status && status !== "All Status" ? `&status=${status}` : ""}${searchVal ? `&search=${searchVal}` : ""}`
                        const reports = await axios.get(filterAndSearchUrl,
                            {
                                headers: {
                                    Authorization: `Bearer ${storedToken}`,
                                },
                            }
                        )
                        setData(reports?.data)
                        setLoading(false);
                    } else {
                        setLoading(true);
                        // setCurrentFilterCount(10)

                        const filterAndSearchUrl = `${process.env.REACT_APP_API_URL}/api/cust-portal/push-button-alerts?first=0&rows=20&${fromdate ? `rangeDates=${fromdate}` : ""}${todate ? `&rangeDates=${todate}` : ""}${globalstorevalue ? `&stores=${globalstorevalue}` : ""}${status && status !== "All Status" ? `&status=${status}` : ""}${searchVal ? `&search=${searchVal}` : ""}`
                        const reports = await axios.get(filterAndSearchUrl,
                            {
                                headers: {
                                    Authorization: `Bearer ${storedToken}`,
                                },
                            }
                        )
                        setData(reports?.data)
                        setLoading(false);
                    }
                }
            }
        } catch (error: any) {
            toast.error(error?.response?.data?.message || error?.message || "Something went wrong!");
            setLoading(false)
        }
    };

    async function handleFilteredResultLazyLoad() {
        if (isAllDataFetched) return;

        let newFirst = currentFilterCount;

        try {
            setInnerLoading(true);

            const filterAndSearchUrl = `${process.env.REACT_APP_API_URL}/api/cust-portal/push-button-alerts?first=${newFirst}&rows=20&${fromdate ? `rangeDates=${fromdate}` : ""}${todate ? `&rangeDates=${todate}` : ""}${globalstorevalue ? `&stores=${globalstorevalue}` : ""}${status && status !== "All Status" ? `&status=${status}` : ""}${searchVal ? `&search=${searchVal}` : ""}`;
            const response = await axios.get(filterAndSearchUrl,
                {
                    headers:
                    {
                        Authorization: `Bearer ${storedToken}`,
                    }
                }
            )
            const newData = response?.data || [];

            if (newData.length === 0) {
                setIsAllDataFetched(true);
                setCurrentFilterCount(20);
            } else {
                setData((prevData) => [...prevData, ...newData]);

                // Initialize video loading state for new data
                const newVideoLoadingState = {};
                newData.forEach((_, index) => {
                    newVideoLoadingState[currentFilterCount + index] = true;  // Set initial loading state to false
                });

                setVideoLoading((prevLoading) => ({
                    ...prevLoading,
                    ...newVideoLoadingState,  // Add the new loading states while preserving the old ones
                }));

                setCurrentFilterCount((prevCount) => {
                    const newCount = prevCount + newData?.length;
                    return newCount;
                });
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message || "An error occurred. Please try again.");
        } finally {
            setInnerLoading(false);
        }
    }

    function getStatusStyle(status) {
        switch (status) {
            case 'Pending':
                return { color: '#FD5454', textTransform: "uppercase", fontSize: '13px', fontWeight: "700" };
            case 'Solved':
                return { color: '#00B69B', textTransform: "uppercase", fontSize: '13px', fontWeight: "700" };
            case 'Unsolved':
                return { color: '#9F8956', textTransform: "uppercase", fontSize: '13px', fontWeight: "700" };
            default:
                return { color: '#9F8956', textTransform: "uppercase", fontSize: '13px', fontWeight: "700" };
        }
    }

    const truncateText = (text, length) => {
        if (text?.length > length) {
            return text.substring(0, length) + '...';
        }
        return text;
    };

    const triggerColumns: CustomColumn[] = [
        {
            key: "index",
            label: "S.No",
            width: "6%",
            render: (_: any, __: any, index: number) => (
                <span className="text-[rgb(var(--text-muted))] text-[12px]">{index + 1}</span>
            ),
        },
        {
            key: "store_name",
            label: "Store Name",
            width: "18%",
            render: (value: string) => (
                <div className="flex items-center gap-2">
                    <img className="w-6 h-6 rounded" src={camera} alt="Camera" />
                    <span className="font-medium text-[rgb(var(--text-primary))]">{value}</span>
                </div>
            ),
        },
        {
            key: "reason",
            label: "Reason",
            width: "16%",
            render: (value: string) => (
                <span className="text-[rgb(var(--text-secondary))] text-[12px]">
                    {value ? truncateText(value, 40) : "NA"}
                </span>
            ),
        },
        {
            key: "time",
            label: "Date",
            width: "22%",
            render: (value: string) => (
                <span className="text-[12px] text-[rgb(var(--text-secondary))]">
                    {moment(value).format("DD/MM/YYYY hh:mm:ss A")}
                </span>
            ),
        },
        {
            key: "resolution_status",
            label: "Status",
            width: "14%",
            render: (value: string) => {
                let variant: "success" | "warning" | "danger" | "info" | "neutral" = "neutral";
                if (value === "Solved") variant = "success";
                else if (value === "Pending") variant = "danger";
                else if (value === "Unsolved") variant = "warning";
                return <StatusChip label={value || "N/A"} variant={variant} />;
            },
        },
        {
            key: "video_link",
            label: "Video",
            width: "24%",
            align: "center",
            render: (value: string, row: any, index: number) => {
                if (!value) {
                    return <span className="text-[11px] text-[rgb(var(--text-muted))]">No Video</span>;
                }
                return (
                    <div
                        className="w-[90px] h-[55px] overflow-hidden rounded relative cursor-pointer"
                        onClick={(e) => { e.stopPropagation(); handleOpenDialog(row, index); }}
                    >
                        <img
                            className="w-full h-full object-cover rounded"
                            src={row?.poster_url}
                            alt=""
                        />
                        <PlayCircleIcon
                            sx={{ color: "white", fontSize: "22px", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
                        />
                    </div>
                );
            },
        },
    ];

    return (
      <>
        <VideoDialog
          visible={visible}
          onHide={handleCloseDialog}
          data={Data}
          currentIndex={currentVideoIndex}
          onIndexChange={(i) => {
            setCurrentVideoIndex(i);
            setVideoSrc(Data[i]?.video_link || "");
            setVideoHeader(Data[i]?.store_name || "");
          }}
          onLoadMore={filterVal ? handleFilteredResultLazyLoad : handleLazyLoad}
          isAllDataFetched={isAllDataFetched}
          defaultSidebarOpen={true}
          sidebarContent={(onSelect) => (
            <VideoSidebar
              data={Data}
              currentIndex={currentVideoIndex}
              onSelect={(i) => {
                onSelect(i);
                setCurrentVideoIndex(i);
                setVideoSrc(Data[i]?.video_link || "");
                setVideoHeader(Data[i]?.store_name || "");
              }}
              onClose={() => setOpenDrawer(false)}
              isAllDataFetched={isAllDataFetched}
              onLoadMore={
                filterVal ? handleFilteredResultLazyLoad : handleLazyLoad
              }
            />
          )}
        />

        <div>
          {totalCount === 0 && !loading ? (
            <div className="py-10 text-center">
              <h3 className="text-[rgb(var(--text-muted))] text-sm font-semibold">
                No Data is available.
              </h3>
            </div>
          ) : (
            <CustomDataTable
              columns={triggerColumns}
              data={Data}
              rowKey="_id"
              loading={loading}
              skeletonRows={5}
              emptyMessage="No trigger alerts data available."
              maxHeight="calc(100vh - 400px)"
              onScrollEnd={
                filterVal ? handleFilteredResultLazyLoad : handleLazyLoad
              }
              hasMore={!isAllDataFetched}
              loader={
                <div className="flex justify-center py-4">
                  <span className="text-[12px] text-[rgb(var(--text-muted))]">
                    Loading more...
                  </span>
                </div>
              }
              endMessage={<span>No More Data</span>}
              header={
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
                  <DescriptionBox
                    title="Push Button"
                    subTitle="Trigger Alerts"
                    description="Alert history triggered by push button events across all locations."
                  />
                  <div className="flex items-center gap-2">
                    <SearchBar
                      searchVal={searchVal}
                      setSearchVal={setSearchVal}
                      fetchFilteredData={fetchFilteredData}
                    />
                    <TriggerFilterModal
                      Data={Data}
                      setData={setData}
                      setFilterVal={setFilterVal}
                      setLoading={setLoading}
                      loading={loading}
                      totalCount={totalCount}
                      setTotalCount={setTotalCount}
                      setCurrentCount={setCurrentCount}
                      isAllDataFetched={isAllDataFetched}
                      setIsAllDataFetched={setIsAllDataFetched}
                      filterVal={filterVal}
                      isInnerDataLoading={isInnerDataLoading}
                      setInnerDataLoading={setInnerDataLoading}
                      searchVal={searchVal}
                      status={status}
                      setStatus={setStatus}
                      todate={todate}
                      setTodate={setTodate}
                      fromdate={fromdate}
                      setFromdate={setFromdate}
                      reload={reload}
                      setReload={setReload}
                      fetchCountAndData={fetchCountAndData}
                      setCount={setCount}
                      currentFilterCount={currentFilterCount}
                      setCurrentFilterCount={setCurrentFilterCount}
                      fetchFilteredData={fetchFilteredData}
                    />
                  </div>
                </div>
              }
            />
          )}
        </div>
      </>
    );

}

